import React from 'react'
import { withTranslation } from 'react-i18next'

const TermsOfUse = ({ t }) => (
    <div className="policy-page">
        <h1>{t('_pages._terms_of_use.title')}</h1>
        <h3>{t('_pages._terms_of_use.last_updated')}</h3>
        <br />
        <br />
        <br />
        <p>{t('_pages._terms_of_use.text_1')}</p>
        <br />
        <p>{t('_pages._terms_of_use.text_2')}</p>
        <br />
        <p>{t('_pages._terms_of_use.text_3')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.scope_of_agreement')}</h2>
        <p>{t('_pages._terms_of_use.text_4')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.company_is_a_venue')}</h2>
        <p>{t('_pages._terms_of_use.text_5')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.licenses')}</h2>
        <p>{t('_pages._terms_of_use.text_6')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.privacy')}</h2>
        <p>{t('_pages._terms_of_use.text_7')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.proprietary_rights_of_company')}</h2>
        <p>{t('_pages._terms_of_use.text_8')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.general_representations')}</h2>
        <p>{t('_pages._terms_of_use.text_9')}</p>
        <br />
        <ul>
            <li>{t('_pages._terms_of_use.text_10_1')}</li>
            <li>{t('_pages._terms_of_use.text_10_2')}</li>
            <li>{t('_pages._terms_of_use.text_10_3')}</li>
            <li>{t('_pages._terms_of_use.text_10_4')}</li>
            <li>{t('_pages._terms_of_use.text_10_5')}</li>
            <li>{t('_pages._terms_of_use.text_10_6')}</li>
            <li>{t('_pages._terms_of_use.text_10_7')}</li>
            <li>{t('_pages._terms_of_use.text_10_8')}</li>
            <li>{t('_pages._terms_of_use.text_10_9')}</li>
            <li>{t('_pages._terms_of_use.text_10_10')}</li>
            <li>{t('_pages._terms_of_use.text_10_11')}</li>
            <li>{t('_pages._terms_of_use.text_10_12')}</li>
        </ul>
        <br />
        <p>{t('_pages._terms_of_use.text_11')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.links')}</h2>
        <p>{t('_pages._terms_of_use.text_12')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.logos_and_names')}</h2>
        <p>{t('_pages._terms_of_use.text_13')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.limitation_of_liability')}</h2>
        <p>{t('_pages._terms_of_use.text_14')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.indemnity')}</h2>
        <p>{t('_pages._terms_of_use.text_15')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.governing_law')}</h2>
        <p>{t('_pages._terms_of_use.text_16')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.claims_of_infringement')}</h2>
        <p>{t('_pages._terms_of_use.text_17')}</p>
        <br />
        <ul>
            <li>{t('_pages._terms_of_use.text_18_1')}</li>
            <li>{t('_pages._terms_of_use.text_18_2')}</li>
            <li>{t('_pages._terms_of_use.text_18_3')}</li>
            <li>{t('_pages._terms_of_use.text_18_4')}</li>
            <li>{t('_pages._terms_of_use.text_18_5')}</li>
        </ul>
        <br />
        <p>{t('_pages._terms_of_use.text_19')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.legal_department')}</h2>
        <p>{t('_pages._terms_of_use.address')}</p>
        <p>
            {t('_common.email')}: <a href="mailto:info@interacty.me">info@interacty.me</a>
        </p>
        <br />
        <br />
        <p>{t('_pages._terms_of_use.text_20')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.term_and_termination')}</h2>
        <ul>
            <li>
                <strong>{t('_pages._terms_of_use.term_of_agreement')}</strong> {t('_pages._terms_of_use.text_21_1')}
            </li>
            <li>
                <strong>{t('_pages._terms_of_use.term_of_purchased_subs')}</strong>
                <br />
                {t('_pages._terms_of_use.text_21_2')}
            </li>
            <li>
                <strong>{t('_pages._terms_of_use.termination')}</strong>
                <br />
                {t('_pages._terms_of_use.text_21_3')}
            </li>
        </ul>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.refund')}</h2>
        <p>{t('_pages._terms_of_use.text_22')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.copyright_notice')}</h2>
        <p>{t('_pages._terms_of_use.text_23')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.communication')}</h2>
        <p>{t('_pages._terms_of_use.text_24')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.newsAndUpdateEmails')}</h2>
        <p>{t('_pages._terms_of_use.text_26')}</p>
        <br />
        <br />
        <h2>{t('_pages._terms_of_use.other')}</h2>
        {t('_pages._terms_of_use.text_25')}
        <br />
        <br />
    </div>
)

export default withTranslation('translations')(TermsOfUse)
